// Module 16 — the per-navigation draft drop (ORP-18753 AC7), contributed to 05's `registerNavReset`
// exactly as module 08 contributes `registerReportNavResets`.
//
// SCOPE: the DRAFT only. Jobs, limits and templates are `{accountUserId, workspaceId}`-scoped and
// survive a navigation on purpose — re-fetching the whole list because the user visited Summary and
// came back would be a regression, and `registerDataExportLifecycle` already clears every field on
// the two edges that actually invalidate them (workspace switch, logout).
//
// Registered through the afterEach registry, never a beforeEach: `cancelInFlightGuard` must abort
// before anything clears (v3 `router/index.js:64-73` order, locked by `reportNavResetOrder.spec`).
//
// v3 had no equivalent: the wizard lived on the page, so navigating away unmounted it and the 36
// refs died with the component. The v4 draft outlives its host — it is store state — so the drop
// has to be explicit or a half-finished export would still be there on the user's next visit.
import { useDataExportStore } from '../stores/dataExportStore'

export type NavResetRegister = (reset: () => void) => void

/**
 * The store is resolved INSIDE the callback, not at registration time: the shell registers during
 * boot composition, and resolving a Pinia store then would bind to whatever instance was active at
 * that moment (and throw outright if none is active yet).
 */
export function registerDataExportNavResets(register: NavResetRegister): void {
  register(() => {
    useDataExportStore().resetDraft()
  })
}
